export const API_URL = "https://pbxstatus.wildix.com/api/v1";
export default API_URL;
